import * as React from 'react';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import usePageBackground from "../hooks/usePageBackground";
import { useNavigate } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemButton, ListItemText, Box, Button, Container, ImageList, ImageListItem } from '@mui/material';
import { UserContexto } from '../app';
import { styled } from '@mui/material/styles';
import '../css/nav.css';
import '../css/global.css';
import recepcionImg from '../assets/images/espacios/recepcion.jpeg';
import entrada from '../assets/images/espacios/entrada.jpeg';
import entrada2 from '../assets/images/espacios/entrada_2.jpeg';
import salaEspera from '../assets/images/espacios/sala_espera.jpeg';
import despacho9 from '../assets/images/espacios/Despacho9.jpeg';
import despacho5 from '../assets/images/espacios/Despacho5.jpeg';
import despacho3 from '../assets/images/espacios/Despacho3.jpeg';
import despacho10 from '../assets/images/espacios/Despacho10.jpeg';
import despacho11 from '../assets/images/espacios/Despacho11.jpeg';
import FadeItem from "../components/fadeItem";
import { useFadeInOnScroll } from "../theme/global";
import Loader from '../components/loader';



const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1.5 } },
  };
  

  const OurSpaces = () => {
    const [loading, setLoading] = useState(true);
    const textInicio = [
      "Descubre nuestros espacios diseñados para brindarte una experiencia de bienestar integral. Al entrar, te recibirá una acogedora recepción, donde te sentirás cómodo y bienvenido desde el primer momento. ",      "Contamos con despachos privados para consultas de fisioterapia, nutrición y psicología, ofreciendo un ambiente tranquilo e íntimo para una atención personalizada. Además, disponemos de una amplia sala común, un espacio versátil donde se realizan clases de yoga, biodanza y diversas charlas y talleres.  ",      "Cada rincón de nuestro local está pensado para promover la serenidad y el equilibrio, creando un entorno ideal para el cuidado de la mente, el cuerpo y el alma.",
    ];

    usePageBackground('ourSpaces-background-color');
    useEffect(() => { setLoading(false); }, []);
  
    
  
    const recepcionRef = useFadeInOnScroll([loading]);
    const gridRef = useFadeInOnScroll([loading]);
      
  
      const itemData = [
        { img: entrada, title: "Entrada", cols: 2, rows: 1, },
        { img: salaEspera, title: "Sala de espera", cols: 1, rows: 1, },
        { img: despacho9, title: "Despacho9", cols: 1, rows: 1, },
        { img: despacho5, title: "Despacho5", cols: 1, rows: 2, },
        { img: despacho3, title: "Despacho3", cols: 1, rows: 1, },
      ];

      const itemGrid = [
        { img: entrada2, title: "Entrada2", area: "entrada2" },
        { img: salaEspera, title: "SalaEspera", area: "sala" },
        { img: despacho9, title: "Despacho9", area: "despacho9" },
        { img: despacho5, title: "Despacho5", area: "despacho5" },
        { img: despacho3, title: "Despacho3", area: "despacho3" },
        { img: despacho10, title: "Despacho10", area: "despacho10" },
        { img: despacho11, title: "Despacho11", area: "despacho11" },
      ];
                   
if (loading) return <Loader />;
return (
    <>
    <Helmet>
      <title>Nuestros Espacios | CES</title>
      <meta name="description" content="Conoce las instalaciones de CES." />
    </Helmet>
    <Box   sx={{ textAlign: "center", my: "2.5em", mx: "auto", p: "2.5em", minHeight: "100vh",  display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", overflow: 'hidden', width: "100%",  }}>
      <Container   maxWidth={false} sx={{ mt: 2, marginBottom: '1.5em' }}>
      <FadeItem
        text="Nuestros espacios"
        variant="h2"
        style={{ fontFamily: "Great Vibes, cursive", fontWeight: 500, color: "var(--color-light-beige)", mb: 2 }}
      />
      <Box
             ref={recepcionRef}
             className="fade-up"
             maxWidth={false}
           component="img"
            src={recepcionImg}
            alt="Recepción"
            // className="fade-up"
            sx={{ 
            flex: 1, // Esto hace que el box de la imagen ocupe el mismo tamaño que el texto
            width: "100%", 
            maxWidth: "700px", // Ajusta el tamaño máximo en pantallas grandes
            borderRadius: "8px", 
            boxShadow: 3, 
            objectFit: "cover", // Asegura que la imagen no se distorsione
            height: "auto", // Mantiene la proporción de la imagen
            maxHeight: "400px", // Limita la altura máxima de la imagen
            }} 
        />
      {textInicio.map((text, index) => (
        <FadeItem
          key={index}
          text={text}
          style={{ fontFamily: "Raleway, sans-serif", fontWeight: 400, fontSize: "1.125em", color: "#686422", mb: 2, alignContent: "center",
            marginTop: '2em', lineHeight: '1.25em',
          }}
        />
      ))}
        </Container>   

            {/* Galería de imágenes */}
          {/* <Container maxWidth="lg" sx={{ mt: 4 }}>
            <ImageList variant="masonry" cols={2} gap={20} sx={{ padding: 4 }}>
              {itemData.map((item, index) => (
                <ImageListItem key={index} cols={item.cols || 1} rows={item.rows || 1}>
                  <img
                    className="fade-up"
                    src={item.img}
                    alt={item.title}
                    loading="lazy"
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      boxShadow: "0.3em 0.3em 0.5em rgba(0,0,0,0.2)",
                    }}
                  />
                </ImageListItem>
              ))}
            </ImageList>
          </Container> */}

              {/* Galería con Grid */}
              <Container maxWidth="lg">
                <Box
                  ref={gridRef}
                  className="fade-up"
                  sx={{
                    display: "grid",
                    marginTop: "3rem",
                    marginBottom: '2rem',
                    gridTemplateColumns: {
                      xs: "repeat(1, 1fr)",   // móviles: 2 columnas
                      sm: "repeat(3, 1fr)",   // tablets: 3 columnas
                      md: "repeat(9, 1fr)",   // escritorio: tu layout original
                    },
                    gridAutoRows: {
                      xs: "180px",
                      sm: "180px",
                      md: "120px",
                    },
                    gap: "2em", // Espaciado entre imágenes
                    // gridTemplateAreas: `
                    //   ". entrada2 entrada2 entrada2 sala sala sala sala sala"
                    //   ". entrada2 entrada2 entrada2 sala sala sala sala sala"
                    //     ". entrada2 entrada2 entrada2 sala sala sala sala sala"
                    //    "despacho5 despacho5 despacho5 despacho5 despacho9 despacho9 despacho9 despacho9 ."
                    //   "despacho5 despacho5 despacho5 despacho5 despacho9 despacho9 despacho9 despacho9 ."
                    //   "despacho5 despacho5 despacho5 despacho5 despacho3 despacho3 despacho3 despacho3 despacho3"                     
                    //   "despacho10 despacho10 despacho10 despacho10 despacho3 despacho3 despacho3 despacho3 despacho3"
                    //   "despacho10 despacho10 despacho10 despacho10 despacho11 despacho11 despacho11 despacho11 ."
                    //   "despacho10 despacho10 despacho10 despacho10  despacho11 despacho11 despacho11 despacho11 ."
                    //    ". . . . despacho11 despacho11 despacho11 despacho11 ."
                    // `,
                     gridTemplateAreas: {
                      xs: undefined,
                      sm: undefined,
                      md: `
                        ". entrada2 entrada2 entrada2 entrada2 sala sala sala sala"
                        ". entrada2 entrada2 entrada2 entrada2 sala sala sala sala"
                        ". entrada2 entrada2 entrada2 entrada2 sala sala sala sala"
                        "despacho5 despacho5 despacho5 despacho9 despacho9 despacho9 despacho9 despacho9 ."
                        "despacho5 despacho5 despacho5 despacho9 despacho9 despacho9 despacho9 despacho9 ."
                        "despacho5 despacho5 despacho5 . despacho3 despacho3 despacho3 despacho3 despacho3"
                        "despacho10 despacho10 despacho10 despacho10 despacho3 despacho3 despacho3 despacho3 despacho3"
                        "despacho10 despacho10 despacho10 despacho10 despacho11 despacho11 despacho11 despacho11 ."
                        "despacho10 despacho10 despacho10 despacho10 despacho11 despacho11 despacho11 despacho11 ."
                        ". . . . despacho11 despacho11 despacho11 despacho11 ."
                      `,
                    },
                  }}
                >
                  {itemGrid.map((item, index) => (
                    <Box
                      component="img"
                      key={index}
                      src={item.img}
                      alt={item.title}
                      loading="lazy"
                      // className="fade-up"
                      sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        boxShadow: '2px 2px 8px rgba(0,0,0,0.2)',
                          gridArea: {
                          xs: "auto",
                          sm: "auto",
                          md: item.area,
                        },
                      }}
                    />
                  ))}
                </Box>
              </Container>

      </Box>
    </>
    
  );
};

export default OurSpaces;
